import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const RED = '#b91d47', RED_D = '#8f1538', INK = '#1c1c28', GREY = '#7a7a8c', GREEN = '#22a06b';

export default function AppSaved() {
  const navigate = useNavigate();
  const [saved, setSaved] = useState([]);

  useEffect(() => {
    try {
      const s = JSON.parse(localStorage.getItem('savedSalons') || '[]');
      setSaved(Array.isArray(s) ? s : []);
    } catch (e) { setSaved([]); }
  }, []);

  const remove = (id) => {
    const next = saved.filter(s => (s.salon_id || s.id) !== id);
    setSaved(next);
    localStorage.setItem('savedSalons', JSON.stringify(next));
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f4f6fb', maxWidth: 480, margin: '0 auto' }}>
      <div style={{ background: `linear-gradient(135deg,${RED},${RED_D})`, color: '#fff', padding: '20px 16px', display: 'flex', alignItems: 'center', gap: 14 }}>
        <span onClick={() => navigate('/app/profile')} style={{ fontSize: 24, cursor: 'pointer' }}>‹</span>
        <div style={{ fontSize: 18, fontWeight: 700 }}>Saved Salons</div>
      </div>

      <div style={{ padding: 16 }}>
        {saved.length === 0 ? (
          <div style={{ textAlign: 'center', padding: 50, color: GREY }}>
            <div style={{ fontSize: 50 }}>♡</div>
            <div style={{ fontSize: 16, fontWeight: 700, color: INK, marginTop: 12 }}>No saved salons</div>
            <div style={{ fontSize: 13, marginTop: 6 }}>Tap the heart on any salon to save it here.</div>
            <button onClick={() => navigate('/app/home')} style={{ marginTop: 20, background: RED, color: '#fff', border: 'none', borderRadius: 12, padding: '12px 28px', fontWeight: 700, cursor: 'pointer' }}>Explore Salons</button>
          </div>
        ) : (
          saved.map((s, i) => (
            <div key={i} style={{ background: '#fff', borderRadius: 14, padding: 12, display: 'flex', gap: 12, alignItems: 'center', marginBottom: 12, boxShadow: '0 2px 8px rgba(28,28,40,.05)' }}>
              <div onClick={() => { const id = s.salon_id || s.id; sessionStorage.setItem('app_salon_' + id, JSON.stringify(s)); navigate('/app/salon/' + id); }} style={{ width: 60, height: 60, borderRadius: 12, background: s.photo_url ? `url(${s.photo_url}) center/cover` : 'linear-gradient(135deg,#e2c4b8,#c99d8a)', flexShrink: 0, cursor: 'pointer' }} />
              <div style={{ flex: 1 }} onClick={() => { const id = s.salon_id || s.id; sessionStorage.setItem('app_salon_' + id, JSON.stringify(s)); navigate('/app/salon/' + id); }}>
                <div style={{ fontSize: 15, fontWeight: 700, color: INK }}>{s.salon_name || s.name}</div>
                <div style={{ fontSize: 12, color: GREY, marginTop: 3 }}>{s.business_type === 'parlour' ? 'Parlour' : 'Salon'}</div>
              </div>
              <span onClick={() => remove(s.salon_id || s.id)} style={{ fontSize: 22, cursor: 'pointer', color: RED }}>♥</span>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
